import React, { useRef, useEffect, useState } from "react";

import useHttp from "../../../../hooks/use-http";

import moment from "moment";
import convertToExcel from "../../../../components/ExportToExcel";
import Pagination from "../../../../components/Pagination";
import { useNavigate  } from "react-router-dom";

const FarmerSoilDetailReport = () => {
  const frmRef = useRef({});
  const navigate  = useNavigate ();
  const handleButtonClick = () => {
    navigate("/farmerwise");
  };
  const [employeeId, setEmployeeId] = useState();
  const [employeeData, setEmployeeData] = useState([]);
  const [employeeAllData, setEmployeeAllData] = useState([]);
  const [regionId, setRegionId] = useState();
  const [regionData, setRegionData] = useState([]);

  const [collectionCenterId, setCollectionCenterId] = useState();
  const [collecticnCenterdata, setCollectionCenter] = useState([]);
  const [data, setData] = useState([]);
  
  const [itemsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = data && data.slice(indexOfFirstItem, indexOfLastItem);
  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };


  const {
    
    sendRequest: getWarehouseData,
  } = useHttp();

  const [cropAreaData, setCropAreaData] = useState([]);

  const [cropwiseAreaCovered, setcropwiseAreaCovered] = useState([]);
  const [executivewiseProcurement, setexecutivewiseProcurement] = useState([]);
  const [executivewiseAreaCovered, setexecutivewiseAreaCovered] = useState([]);

  const [selectedDate, setSelectedDate] = useState(
    new Date().toISOString().substr(0, 10)
  );

  const handleFDateChange = (e) => {
    //console.log("handleFDateChange",e.target.value)
    setSelectedFromDate(e.target.value);
  };
  const handleTDateChange = (e) => {
    setSelectedToDate(e.target.value);
  };


  // var date =date.setDate(date.getDate() + 10);

  const currentDate = new Date().toISOString().slice(0, 10);
  var d = new Date();
  d.setDate(d.getDate() -15);


  const fromDate =d.toISOString().slice(0, 10);
  const [selectedFromDate, setSelectedFromDate] = useState(
    fromDate
  );
  
  const toDate  = new Date().toISOString().slice(0, 10);
  
  //console.log("toDate",toDate)

  const [selectedToDate, setSelectedToDate] = useState(
    toDate
  );


  const {
  
    sendRequest: getprocurementData,
  } = useHttp();

  const loadCountData = (id) => {
    fillSoilObservationData(id);
  };



  function toColor(num) {
    num >>>= 0;
    var b = num & 0xFF,
        g = (num & 0xFF00) >>> 8,
        r = (num & 0xFF0000) >>> 16,
        a = ( (num & 0xFF000000) >>> 24 ) / 255 ;
    return "rgba(" + [r, g, b, a].join(",") + ")";
}

  const fillSoilObservationData = (employeeId, regionId) => {
    var urlfilter = "";
    if (employeeId > 0) {
      urlfilter = `&fieldExecutiveId=${employeeId}`;
    }

    if (regionId > 0) {
      urlfilter = urlfilter + `&regionId=${regionId}`;
    }

    var url = `/api/soilwaterreport/?orgId=${localStorage.getItem(
      "orgId"
    )}${urlfilter} `;

    getprocurementData(
      {
        url: url,
      },
      (data) => {
        // //console.log("counts", data);

        var i = 0;
        var newList = [];
        var cropnameList = [];
        var j = 0;
        var soilwaterData = data;

        if(soilwaterData.length>0)
        {
        do {
          var soilwateritem = soilwaterData[i];
          var stragronomy= JSON.stringify(soilwateritem.agronomy);
          var agronomylist =JSON.parse( JSON.parse(stragronomy));

         
         var k=0 
        do {

          var agronomyItem=agronomylist[k];
        
          var strsoilwater= JSON.stringify(agronomyItem);

          var soilwater = JSON.parse(strsoilwater);

          // if ((soilwater.agronomyId ?? "") == "") {
          //   procurement = JSON.parse(procurement);
          // }
          
          
          //console.log("soilwater", soilwater);
          soilwater = JSON.parse(strsoilwater);
          //console.log("soilwater.soilObservation", soilwater.soilObservation);
          
          var strsoilObservation = JSON.stringify(
            soilwater.soilObservation
          );
         
          strsoilObservation=strsoilObservation.replace('\\','');
          //console.log("strsoilObservation", strsoilObservation);
          var soilObservation =JSON.parse(JSON.parse(strsoilObservation));
          //console.log("soilObservation", soilObservation);
            
          //console.log("porosity", soilObservation.porosity);
          var strporosity = JSON.stringify(
            soilObservation.porosity
          );
            var porosity =  (JSON.parse(strporosity));
            //console.log("porosity", porosity);

            newList = newList.concat({
            linesrno: j + 1,
            cropPlotId: soilwateritem.cropPlotId,
            plotId: soilwateritem.plotId,
            cropId: soilwateritem.cropId,
            varietyId: soilwateritem.varietyId,
            fieldExecutiveId: soilwateritem.fieldExecutiveId,
            fieldExecutiveName: soilwateritem.fieldExecutiveName,
            regionId: soilwateritem.regionId,
            regionName: soilwateritem.regionName,
            farmerNo: soilwateritem.farmerNo,
            farmerName: soilwateritem.farmerName,
            plotName: soilwateritem.plotName,
            plotArea: soilwateritem.plotArea,
            plotAreaUnit: soilwateritem.plotAreaUnit,
            cropName: soilwateritem.cropName,
            cropTypeName: soilwateritem.cropTypeName,
            varietyName: soilwateritem.varietyName,
            sowingDate: soilwateritem.sowingDate,
            pruningDate: soilwateritem.pruningDate,
            harvestingDate: soilwateritem.harvestingDate,
            soilObservationDate:    soilwater.date,
            texture :    soilObservation.texture,
            structure :    soilObservation.structure,
            density :    soilObservation.density,
            soilType :    porosity.soilType,
            fieldCapacity :    porosity.fieldCapacity,
            writingPoints :    porosity.writingPoints,              
            temperature :    soilObservation.temperature,
            color :    toColor(soilObservation.color),
          		


            // surveyNumberGutNumber: soilwateritem.surveyNumberGutNumber,
            // procurementDate: procurement.procurementDate,
            // fieldPackagingDate: fieldPackaging.fieldPackagingDate,
            // totalProcurment: procurement.totalQty,
            // unit: outputQtyUnit,
            // totalValue: parseFloat(procurement.advanceAmount??0)+parseFloat(procurement.balanceAmount??0) , // procurement.totalAmount, 
            
           

            // advance: procurement.advanceAmount,
            // totalBalance: procurement.balanceAmount,
          });
          k++;
        } while (agronomylist.length > k);

          i++;

        } while (soilwaterData.length > i);

      }
        //console.log("inewList", newList);
        setData(newList);
      }
    );
  };

  useEffect(() => {
    fillSoilObservationData(0, 0);
  }, [getprocurementData]);

  
   

  const fieldsToExport = [
    "farmerName",
    "farmerNo",
    "fieldExecutiveName",
    "regionName",
    "plotName",
    
    "cropTypeName",
    "cropName",
    "varietyName",
    "plotArea",
    "plotAreaUnit",
    "sowingDate",
    "pruningDate",
    "surveyNumberGutNumber",
    "estimationDate",  
    "estimation", 
    "estimationUnit",
   
];

const customHeaders = 
[
  "Farmer Name",
"Farmer Code",
"Executive Name",
"Region Name",
"Plot Name",
"crop Type",
"Crop Name",
"Variety Name",
"Plot Area",
"Unit",
"Sowing Date",
"Pruning Date",
"Survey No", 
"Estimation Date",                
"Estimation",
"Estimation Unit",

];

const handleExportExcel = () => {
  const filename = "YieldEstimationsReport.xlsx";
  //console.log(fieldsToExport,customHeaders);

  convertToExcel(data, fieldsToExport, filename, customHeaders);
};

const {

  sendRequest: getEmp,
} = useHttp();



const EmployeeDetail = (region) => {
  var urlfilter = "";

  if (region > 0) {
    urlfilter = urlfilter + `&regionId=${region}`;
  }
  getEmp(
    {
      url: `/api/fillEmployeeForReortwithCase/?useCase=Procurement&empId=${localStorage.getItem(
        "empId"
      )}&orgId=${localStorage.getItem("orgId")}${urlfilter} `,
    },
    (data) => {
      console.log("emp", data);
      var emplist = data;

      setEmployeeData(emplist);
      setEmployeeAllData(emplist);
    }
  );
};

useEffect(() => {
  EmployeeDetail(0);
}, [getEmp]);




const {
 
  sendRequest: getRegion,
} = useHttp();
useEffect(() => {
  getRegion(
    {
      url: `/api/procurementRegionList/?orgId=${localStorage.getItem("orgId")}`,
    },
    (data) => {
      //console.log("region", data);

      setRegionData(data.data);
    
    }
  );
}, [getRegion]);




  return (
    <>
      <div className="content-wrapper">
      <div className="row mx-2">
          {" "}
          <div className="col-md-8 mt-3">
            {" "}
            <label className="card-title mx-3">Farmer Soil Test Detail Reports</label>
          </div>
          <div className="col-md-4 text-right mt-3">
            <button
              type="button"
              className="btn btn-tool"
              data-card-widget="remove"
              onClick={handleButtonClick}
            >
              <i className="fas fa-times" />
            </button>
          </div>
        </div>
        <section className="content">
          <div className="container-fluid">
          
            <hr />
            <div className="row">
              </div>
            <div className="row">
            <div className="col-md-3">
            <div className="form-group">

            <label >Region</label>
            <select
              id="regionId"
              className="form-control"
              ref={(el) => (frmRef.current["regionId"] = el)}
              value={regionId}
              onChange={(e) => {
                var regid=0;
 
                if(e.target.value!="--Select--")
                   {
                     regid=e.target.value;                     
                   }
                   setRegionId(regid); 
                   EmployeeDetail(regid)
                   setEmployeeId(0);
                   setData([]);
                
              }}
            >
              <option>--Select--</option>
              {regionData &&
                regionData.map((x) => (
                  <option
                    key={x.regionId}
                    user-id={x.regionId}
                    value={x.regionId}
                  >
                    {x.regionName}
                  </option>
                ))}
            </select>
            </div>
            </div>
            <div className="col-md-3">
            <div className="form-group">
            <label htmlFor={"executive_officer"}>{"Procurement Officer"}</label>
            <select
              id="emp_id"
              className="form-control"
              ref={(el) => (frmRef.current["emp_id"] = el)}
              value={employeeId}
              onChange={(e) => {

                var userid=0;
                if(e.target.value!="--Select--")
                   userid=e.target.value;

                setEmployeeId(userid);
                setData([]);
             
              }}
            >
              <option>--Select--</option>
              {employeeData &&
                employeeData.map((x) => (
                  <option key={x.userId} user-id={x.userId} value={x.userId}>
                    {x.employeeName}
                  </option>
                ))}
            </select>
          </div>
          </div>
          <div className="col-md-2">
            <div className="form-group">
            {" "}
            <label htmlFor={"from_date"}>{"From Date"}</label>
            <input
              type={"date"}
              id={"date"}
              required
              // ref={(el) => (frmRef.current["pdate"] = el)}
              className="form-control"
              max={currentDate}
              value={selectedFromDate}
              onChange={handleFDateChange}
            />
          </div>

          </div>
          <div className="col-md-2">
            <div className="form-group">
            <label htmlFor={"to_date"}>{"To Date"}</label>

            <input
              type={"date"}
              id={"date"}
              required
              // ref={(el) => (frmRef.current["pdate"] = el)}
              className="form-control"
              max={currentDate}
              value={selectedToDate}
              onChange={handleTDateChange}
            />
          </div>

           
          </div>
          <div className="col-md-2">
            <div className="form-group">
               
               <label>&nbsp;</label>
                <button
                  className="form-control btn btn-sm btn-primary"
                  onClick={(e) => {
                    fillSoilObservationData(employeeId,regionId);
                  }}
                >
                  Submit
                </button>
              </div>
              </div>
              </div>
          </div>
          <h5>Please select the parameters to get the desired result</h5>
          <hr />
        </section>

        <section className="content">
          <div className="container-fluid">
            <div className="text-right my-2">
              <button
                type="button"
                className="btn btn-sm btn-warning"
                onClick={handleExportExcel}
              >
                
                <i className="fas fa-file-excel"></i>
              </button>
            </div>
            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body" style={{ padding: "0.4rem" }}>
                    <table className="table table-bordered table-responsive text-center table-sm">
                      <thead>
                        <tr className="table-header">
                         <th>Farmer Name</th>
                  <th>Farmer Code</th>
                  <th>Executive Name</th>
                  <th> Region Name</th>
                  <th> Plot Name</th>
                  <th> crop Type</th>
                  <th> Crop Name</th>
                  <th> Variety Name</th>
                  <th> Plot Area</th>
                  <th> Unit</th>
                  <th> Sowing Date </th>
                  <th> Pruning Date</th>
                  <th> Soil Observation Date </th>
                  <th>Texture</th> 
                  <th>Structure </th>
                  <th>Density </th>
                   <th colSpan={3}>Porosity</th> 
                   						

                  
                   <th>Temperature</th>
                  <th> Color</th>
            
                           
                        </tr>
                        <tr className="table-header">
                        <th></th>
                  <th></th>
                  <th></th>
                  <th></th>
                  <th></th>
                  <th></th>
                  <th></th> <th></th> <th></th> <th></th>

                  <th></th> <th></th> <th></th> <th></th>
                  <th></th>
                  <th></th> <th>Soil Type</th> <th>Field Capacity</th> <th>Writing Points</th>
                  <th></th>
                  <th></th>
                    
                        </tr>
                      </thead>

                      <tbody>
                        { currentItems&&
                          currentItems.map((itm, i) => {
                            return (
                              <tr key={i} className="tablerowview">
                                  <td>{itm.farmerName}</td>
                        <td>{itm.farmerNo}</td>
                        <td>{itm.fieldExecutiveName}</td>
                        <td>{itm.regionName}</td>
                        <td>{itm.plotName}</td>

                        <td>{itm.cropTypeName}</td>
                        <td>{itm.cropName}</td>
                        <td>{itm.varietyName}</td>

                        <td> {itm.plotArea} </td>
                        <td> {itm.plotAreaUnit} </td>
                        <td> {itm.sowingDate} </td>
                        <td> {itm.pruningDate} </td>

                        <td> {itm.soilObservationDate} </td>
                        <td> {itm.texture} </td>
                        {/* <td> {itm.batch} </td> */}
                        <td> {itm.structure} </td>
                        <td> {itm.density} </td>
                        <td> {itm.soilType} </td>
                       
                        <td> {itm.fieldCapacity} </td>
                        <td> {itm.writingPoints} </td>
                        <td> {itm.temperature} </td>
                        <td>
                          <div className="circledot"
                          style={{"background-color":itm.color }}  ></div>  
                           
                        

                          </td>
                           
                                  </tr>
                            );
                          })}
                      </tbody>
                    </table>
                  </div>

                  <div className="card-footer clearfix">
                    <Pagination
                      totalItems={data.length}
                      itemsPerPage={itemsPerPage}
                      onPageChange={paginate}
                      currentPage={currentPage}
                      setCurrentPage={setCurrentPage}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default FarmerSoilDetailReport;
